import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import Main from './components/main';

function App() {
  return (
    <>
      <Header />
      <Main />
    </>
  );
}

export default App;